module.exports = __webpack_public_path__ + "media/images/icons/wifi-28c807879f78b19fada26df09468a455.svg";